import { ClaudeTemplate } from "../types";

export const linkedinTemplate: ClaudeTemplate = {
  id: "linkedin",
  tool: "LinkedIn Campaign Manager",
  url: "https://www.linkedin.com/campaignmanager/",
  hierarchy: "Ad account → Campaign group → Campaign → Ads",
  idHint:
    "ID de la campaña (no del campaign group) en la URL al abrirla o en la columna ID",
  steps: `
### 1. Entrar en la cuenta (puede que ya estés dentro)
1. Abre LinkedIn Campaign Manager ({{url}}). Si ya está abierto, sigue.
2. Elige la **Ad account** de {{client}}. Si hay varias, pregunta.

### 2. Campaign group
1. Busca un campaign group **{{names.campaign}}**. Si existe, úsalo; si no, créalo con ese nombre y las fechas {{goal.startDate}} → {{goal.endDate}}, sin presupuesto de grupo.

### 3. Campaign
1. Dentro del grupo, busca la campaña **{{names.order}}**. Si existe, no la dupliques: entra y salta al paso 4.
2. Si no existe, créala:
   - Objective según {{goal.kpi}}: CPM → Brand awareness; CPC → Website visits; CPV → Video views; CPE → Engagement; CPL → Lead generation; CPA → Website conversions.
   - Campaign name: {{names.order}}
   - Audience: Locations {{target.geography}} (país {{goal.country}}), idioma del perfil {{target.language}}, edad {{target.age}}, sexo {{target.gender}}. Atributos profesionales (cargo, sector, tamaño de empresa…): {{target.interests}} / {{target.audience}}. Exclusiones: {{target.exclusions}}.
   - Audience expansion y LinkedIn Audience Network: desactivados, salvo que las notas digan otra cosa.
   - Ad format: según las piezas del bloque "Creatividades" (single image, video, carousel, document…).
   - Budget & schedule: **Lifetime budget** {{goal.budget}}, del {{goal.startDate}} al {{goal.endDate}}.
   - Bidding: por defecto (maximum delivery). Si las notas piden coste controlado, cost cap / manual bid en torno a {{goal.netUnitCost}}.
   - Conversion tracking: el del cliente si el objetivo lo necesita.

### 4. Ads
1. Crea un anuncio por pieza del bloque "Creatividades", con el texto, el titular y el CTA del bloque "Copies" y la URL de destino (con UTM) del bloque "URLs de destino".
2. Página de empresa: la de {{brand}} / {{client}}. Si hay varias, pregunta.
3. Deja la campaña **en borrador** (o en pausa). No la lances sin mi confirmación.
`,
};
